module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("1p9xg"))).then(() => module.bundle.root('gtEzC'));